export default __webpack_public_path__ + "static/media/BOWLANI-app-Logo-with-white-O-bg.93dc781a.svg";